<template>
  <div class="tcb-container">
    <Header />
    <div class="sub-wrap">
      <RouterView />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";

export default {
  name: "DefaultLayout",
  data() {
    return {
      excludePath: ["/index_nicednb.do"],
    };
  },
  computed: {
    mountedHeader() {
      return !this.excludePath.includes(this.$route.path);
    },
    moundtedFooter() {
      return !this.excludePath.includes(this.$route.path);
    },
  },
  components: {
    Header,
    Footer,
  },
};
</script>
